import React, { ReactElement } from 'react';
import {
  Component,
  FilterCombo,
  noDataDropDownRender,
  PuzzleButton,
  HBox,
  WithTooltip,
  VBox,
  TextComponent, FORM_GET_FIELD
} from "puzzle";
import { Field } from "../../../../UI/Field/Field";
import { ComboBoxChangeEvent, ListItemProps } from "@progress/kendo-react-dropdowns";
import { completedSubmissionStatuses } from "../../../../util/Util";
import { MSLA } from "../../../Types";
import { PuzzleTooltip as TpTooltip } from "puzzle/components";

type PROPS = {
  handleChange: (event: ComboBoxChangeEvent) => void,
  mslaLevel: FORM_GET_FIELD,
  mslaLevelData: MSLA[],
  projectId: number,
  submissionStatus: string
};

class MSLAField extends Component<PROPS, {}> {
  tooltip = React.createRef<TpTooltip>();

  /**
   * Msla download action
   * @param mslaResourceId
   */
  downloadMslaFile = (mslaResourceId: string) => {
    const { projectId } = this.props;

    this.dispatch(
      'downloadDocument', '', {
        params: { repositoryTicket: mslaResourceId, projectId }
      }
    );
  };

  /**
   * Msla tooltip render
   */
  createPriorityLevelTooltip = (): JSX.Element => {
    const { mslaLevelData = [] } = this.props;
    let levels;

    levels = (
      <VBox>
        {mslaLevelData.map(({ mslaLevelName, mslaLevelDescription }: any, index: number) => {
          return mslaLevelDescription ? (
            <span key={`${mslaLevelName}_${index}`} className={'pd-msla-tooltip-item'}>
            <TextComponent thickness={'semi-bold'} htmlTag={'span'} className='tp-space-right-half-1'>
              {mslaLevelName}:
            </TextComponent>
            <TextComponent htmlTag={'span'}>
              <span dangerouslySetInnerHTML={{ __html: mslaLevelDescription }} />
            </TextComponent>
        </span>
          ) : null
        })}
      </VBox>
    )

    return levels;
  };

  /**
   * Msla dropdown item render
   *
   * @param li
   * @param itemProps
   */
  mslaItemRender = (li: ReactElement<HTMLLIElement>, itemProps: ListItemProps): React.ReactNode => {
    let hasDownload: string = itemProps.dataItem.mslaResourceId;
    let downloadBtn = null;
    if (!!hasDownload) {
      downloadBtn = <HBox flex1 justifyContentEnd>
        <PuzzleButton
          key={`downloadMsla_${hasDownload}`}
          themeColor={"primary"}
          size={'small'}
          aria-label={this.translate('download')}
          tab-index={0}
          titleText={this.translate('download')}
          iconClass="tp-icon tp-download"
          fillMode="flat"
          onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            e.stopPropagation();
            this.downloadMslaFile(hasDownload);
          }}
          tooltipPosition={'right'}
          withTooltip
        />
      </HBox>
    }

    return React.cloneElement(
      li,
      { ...li.props },
      [...li.props.children, downloadBtn]
    );
  };

  renderBody(): JSX.Element {
    const {
      handleChange,
      mslaLevel,
      mslaLevelData,
      submissionStatus
    } = this.props;

    const hasDescription = mslaLevelData?.some((item: MSLA) => item.mslaLevelDescription);
    const tooltipClass = hasDescription ? 'pd-is-active' : '';
    const identifier = 'mslaLevel';

    return (
      <>
        <Field
          className={'pd-priority-level-field'}
          mandatory
          withAdditionalEl
        >
          <FilterCombo
            data={mslaLevelData}
            disabled={completedSubmissionStatuses.includes(submissionStatus)}
            errorTxt={this.translateErrorMessage(mslaLevel)}
            handleFormChange={handleChange}
            id={identifier}
            itemRender={this.mslaItemRender}
            label={this.translate(`${identifier}`)}
            listNoDataRender={() => noDataDropDownRender(this.translate(`emptyMslaLevel`))}
            name={identifier}
            onChange={handleChange}
            required={true}
            textField='mslaLevelName'
            translateMethod={this.translate.bind(this)}
            valueAsSimpleType={true}
            valueField='mslaLevelId'
            withValidation
            {...mslaLevel}
          />
          <WithTooltip
            className={'pd-tooltip-action-wrap tp-text-ellipsis'}
            context={this}
            title={''}
            htmlTag={'span'}
          >
            <i
              tabIndex={hasDescription ? 0 : 1}
              aria-label={'priority level'}
              aria-hidden={"true"}
              className={`pd-tooltip-action tp-icon tp-info ${tooltipClass} `}
              title={hasDescription ? 'fakeTitle' : ''}
            />
          </WithTooltip>
        </Field>
        <TpTooltip
          tooltipClassName={'pd-msla-tooltip'}
          anchorElement={'target'}
          ref={(el: any) => this.tooltip = el}
          {...(hasDescription && { content: this.createPriorityLevelTooltip.bind(this) })}
          openDelay={1000}
          position="right"
        />
      </>
    )
  }
}

export default MSLAField;

